// extracted by mini-css-extract-plugin
export default {"form":"style_form__StaVr","button":"style_button__dd9ky"};